import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ParameterDocumentLinkSelectorComponent } from './parameter-document-link-selector.component';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { DocumentLinkModalModule } from '../../document-link/document-link-modal/document-link-modal.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [ParameterDocumentLinkSelectorComponent],
  imports: [CommonModule, MaterialModule, DocumentLinkModalModule, MatDialogModule, MatIconModule, MatProgressBarModule],
  exports: [ParameterDocumentLinkSelectorComponent]
})
export class ParameterDocumentLinkSelectorModule {}
